import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';
import { typographyMixin } from '../typographyMixin';
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;
  return token({
    iconColor: "status." + appearance + ".foreground",
    errorColor: 'status.error.fontColor'
  }, function (tokens) {
    var styles = [css(["> ", ":first-child{color:", ";}"], StyledIcon, tokens.iconColor)];
    if (appearance === 'error') {
      styles.push("color: " + tokens.errorColor + ";");
    }
    if (appearance === 'transient') {
      styles.push('font-style: italic;');
    }
    return styles;
  })(props);
};

/** @class InlineFeedbackMixin */
/** @method */
export var InlineFeedbackMixin = function InlineFeedbackMixin(props) {
  return token({
    fontType: 'InlineFeedback.fontType',
    iconSize: 'InlineFeedback.iconSize',
    paddingLeft: 'InlineFeedback.paddingLeft'
  }, function (_ref) {
    var fontType = _ref.fontType,
      iconSize = _ref.iconSize,
      paddingLeft = _ref.paddingLeft;
    return css(["margin:0;", " ", " ", " padding-left:", "px;position:relative;> ", ":first-child{position:absolute;top:0;left:0;height:", "px;width:", "px;margin-top:0;}"], typographyMixin(Object.assign({
      fontType: fontType
    }, props)), spacingMixin(props), appearanceCSS(props), spaceMixin(paddingLeft, function (space) {
      return space.value + iconSize;
    })(props), StyledIcon, iconSize, iconSize);
  });
};